import { useEffectEvent, useEffect } from 'react';

import { type UthoppEventDetail, UTHOPP_EVENT_NAME } from '@helsenorge/framework-utils/uthopp/events';

/**
 * Lytt på uthopp-hendelser
 *
 * @param onHandle Callback som kalles når noen ber om uthopp.
 */
export const useUthoppEvent = (onHandle: (detail: UthoppEventDetail) => void): void => {
  const handleUthopp = useEffectEvent((detail: UthoppEventDetail) => {
    onHandle(detail);
  });

  useEffect(() => {
    const handleUthoppEvent = (event: CustomEvent<UthoppEventDetail>): void => {
      handleUthopp(event.detail);
    };

    document.addEventListener(UTHOPP_EVENT_NAME, handleUthoppEvent);
    return (): void => {
      document.removeEventListener(UTHOPP_EVENT_NAME, handleUthoppEvent);
    };
  }, []);
};
